<template>
  <section class="batches">
    <div class="status">
      <div class="status__heading">
        <h1>
          Batches
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon slot="activator" class="info-icon" v-on="on">mdi-information</v-icon>
            </template>
            <span>Processsed Batches</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="refresh-btn">
                <v-icon
                  class="refresh-icon"
                  v-ripple
                  :color="'#a9a9a9'"
                  v-on="on"
                  @click="refresh"
                >mdi-refresh</v-icon>
              </span>
            </template>
            <span>Refresh data</span>
          </v-tooltip>
        </h1>
      </div>
      <div class="status__column">
        <div class="status__column-heading">VIEW BY STATUS</div>
        <a href @click="refresh()">
          <StatusItem link="/batches/today" :active="todaysBatchesActive" label="Today's">
            <template v-slot:icon>
              <v-icon :color="todaysBatchesColor">mdi-ballot</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/batches/week" :active="weeksBatchesActive" label="Last 7 Days">
            <template v-slot:icon>
              <v-icon :color="weeksBatchesColor">mdi-ballot</v-icon>
            </template>
          </StatusItem>
        </a>
        <a href @click="refresh()">
          <StatusItem link="/batches/" :active="allBatchesActive" label="All">
            <template v-slot:icon>
              <v-icon :color="allBatchesColor">mdi-ballot</v-icon>
            </template>
          </StatusItem>
        </a>
      </div>
    </div>
    <div class="content">
      <BatchesTable :batches="batches" :loading="loading"></BatchesTable>
    </div>
  </section>
</template>

<script>
import BatchesTable from '../components/BatchesTable.vue';
import StatusItem from '../components/StatusItem';
import moment from 'moment';
import API from '../services/API';

export default {
  name: 'batches',
  components: {
    BatchesTable,
    StatusItem,
  },
  data() {
    return {
      batches: [],
      loading: false,
    };
  },
  computed: {
    todaysBatchesColor() {
      return this.$route.path === '/batches/today' ? '#51b71b' : '#a9a9a9';
    },
    weeksBatchesColor() {
      return this.$route.path === '/batches/week' ? '#51b71b' : '#a9a9a9';
    },
    allBatchesColor() {
      return this.$route.path === '/batches/' ? '#cb201f' : '#a9a9a9';
    },
    todaysBatchesActive() {
      return this.$route.path === '/batches/today';
    },
    weeksBatchesActive() {
      return this.$route.path === '/batches/week';
    },
    allBatchesActive() {
      return this.$route.path === '/batches/';
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      this.batches = [];
      API.get('/batches')
          .then((batches) => {
            const today = moment().format('MM-DD-YYYY');
            const sevenDaysAgo = moment()
                .subtract(7, 'd')
                .format('MM-DD-YYYY');
            const formattedDatesBatches = batches.data.map((batch) => {
              batch.formattedDate = moment(batch.date).format('MMM D, YYYY - h:mm a');
              return batch;
            });

            switch (this.$route.path) {
              case '/batches/today':
                this.batches = formattedDatesBatches.reduce((acc, batch) => {
                  const convertedDate = moment(batch.createdAt).format(
                      'MM-DD-YYYY'
                  );
                  return convertedDate === today ? acc.concat(batch) : acc;
                }, []);
                break;
              case '/batches/week':
                this.batches = formattedDatesBatches.reduce((acc, batch) => {
                  const convertedDate = moment(batch.createdAt).format(
                      'MM-DD-YYYY'
                  );
                  return convertedDate >= sevenDaysAgo ? acc.concat(batch) : acc;
                }, []);
                break;
              default:
                this.batches = formattedDatesBatches;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .then(() => (this.loading = false));
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.batches {
  padding: 1.5rem 0;
  width: 100%;
  min-width: 1200px;
  max-width: 2880px;
  height: 100%;
  background: #fff;
  display: grid;
  grid-template-columns: 320px 1fr 60px;

  .status {
    height: 100%;

    display: flex;
    flex-wrap: wrap;

    &__heading {
      height: 10rem;
      width: 100%;
      z-index: 1;

      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        height: 4.7rem;
        width: 20rem;
        color: #212121;
        font-family: Heebo;
        font-size: 3.2rem;
        font-weight: bold;
        line-height: 4.7rem;
        padding-left: 13px;

        .info-icon {
          font-size: 18px;
          margin-bottom: 1.4rem;
        }
      }

      .refresh-btn {
        border: 2px solid #dedede;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 35px;
        width: 35px;
        margin-top: 4px;
        float: right;
      }
    }

    &__column {
      width: 100%;
      height: 100%;
      z-index: 5;

      &-heading {
        margin: 0 auto;
        height: 2.1rem;
        margin-top: 1.7rem;
        margin-bottom: 1.5rem;
        width: 17rem;
        color: #212121;
        font-family: Heebo;
        font-size: 1.4rem;
        font-weight: bold;
        letter-spacing: 1.24px;
        line-height: 2.1rem;
      }

      .divider {
        width: 17rem;
        height: 0.1rem;
        border-bottom: 2px solid #a9a9a9;
        margin: 0.5rem auto;
      }

      & > a {
        text-decoration: none;
      }
    }
  }

  .content {
    height: 100%;
    padding: 20px 0 0 0;

    display: flex;
    flex-direction: column;

    &__actions {
      height: 10rem;
      width: 100%;

      display: flex;

      &-left {
        width: 50%;
        height: 100%;

        display: flex;
        align-items: center;
      }

      &-right {
        width: 50%;
        height: 100%;

        .process {
          width: 100%;
          height: 100%;

          display: flex;
          align-items: center;
          justify-content: flex-end;

          &-urgent,
          &-new {
            font-family: Heebo;
            letter-spacing: 0.5px;
            font-size: 1.5rem;
            line-height: 24px;
            text-align: center;
            text-transform: none;
            width: 48%;
          }

          &-urgent {
            height: 40px;
            min-width: 17.5rem;
            border-radius: 6px;
          }

          &-new {
            height: 40px;
            min-width: 14.5rem;
            border-radius: 6px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
